import CheckboxRenderer from "components/common/ag-grid/CheckboxRenderer";
import EmployeeLinkRenderer from "./EmployeeLinkRenderer";

 export const columnDefs = [
    { 
      headerName: 'ID#',
      field: 'employee_code',
      minWidth: 110,
      cellRenderer: EmployeeLinkRenderer
    },
    { 
      headerName: 'Name',
      field: 'name',
      minWidth: 100,
      cellRenderer: EmployeeLinkRenderer
    },
    { 
      headerName: 'First name',
      field: 'first_name',
      minWidth: 120
    },
    { 
      headerName: 'Last name',
      field: 'last_name',
      minWidth: 130
    },
    { 
      headerName: 'Full of name',
      field: 'full_name',
      minWidth: 200
    },
    { 
      headerName: 'Title',
      field: 'title',
      minWidth: 200
    },
    { 
      headerName: 'Email',
      field: 'email',
      minWidth: 200
    },
    { 
      headerName: 'Gender',
      field: 'gender',
      minWidth: 100,
      cellRenderer: CheckboxRenderer
    },
    { 
      headerName: 'Birthday',
      field: 'birthday',
      minWidth: 120
    },
    { 
      headerName: 'Phone number',
      field: 'phone_number',
      minWidth: 100
    },
    { 
      headerName: 'HR code',
      field: 'hr_code',
      minWidth: 100
    },
    { 
      headerName: 'Department',
      field: 'department.name',
      minWidth: 150
    },
    { 
      headerName: 'Site',
      field: 'site.name',
      minWidth: 150
    },
    { 
      headerName: 'Manager',
      field: 'parent.name',
      minWidth: 100
    },
    { 
      headerName: 'Active',
      field: 'active',
      minWidth: 100,
      cellRenderer: CheckboxRenderer
    },
    { 
      headerName: 'Staff policy',
      field: 'staff_policy',
      minWidth: 120,
    },
    { 
      headerName: 'Position group',
      field: 'position_group.name',
      minWidth: 200
    },
    { 
      headerName: 'Sales team',
      field: 'is_sales',
      minWidth: 120,
      cellRenderer: CheckboxRenderer
    },
    { 
      headerName: 'Working location',
      field: 'hr.working_location_code',
      minWidth: 120,
    },
     { 
      headerName: 'Company',
      field: 'hr.company_name',
      minWidth: 160,
    },
    { 
      headerName: 'Created date',
      field: 'created_at',
      minWidth: 200
    }
  ];